export default {
    model: [
        {
            label: 'Título',
            field: 'title',
            type: 'text'
        },
        {
            label: 'Imagem',
            field: 'file',
            type: 'text',
            condition_field: 'id',
            condition_type_exists: false
        },
        {
            label: 'Início da Vigência',
            field: 'validity_start_date',
            type: 'text'
        },
        {
            label: 'Final da Vigência',
            field: 'validity_end_date',
            type: 'text'
        },

    ]
}
